/* eslint-disable no-useless-constructor */
import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a provider successfully saves one of the profile modules under
 * `/provider-profile/details/` -- experience, cat experience, skills, or what
 * to expect. Paired with `provider-account-info-updated` and
 * `provider-payout-info-updated` to measure completion of the management hub's
 * modules.
 *
 * &nbsp;
 */
export class ProviderProfileInfoUpdated extends AnalyticsEvent {
  eventName = 'provider-profile-info-updated';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.service_offerings.provider_profile;

  constructor(eventProperties: { provider_status: string; module: string }) {
    super(eventProperties);
  }
}
